import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import { FaPlus } from 'react-icons/fa';
import './editar-rede-social.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  faFacebookSquare, faInstagram, faLinkedin, faYoutube,
  faTiktok, faXTwitter, faWhatsapp, faTelegram, faTumblrSquare
} from '@fortawesome/free-brands-svg-icons';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Radio,
  RadioGroup,
  TagLabel,
  TagCloseButton,
  Wrap,
  WrapItem,
  FormHelperText,
  Spinner,
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  Tooltip,
  IconButton
} from '@chakra-ui/react';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/redesSociais';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { listarExecutores } from '../../../../api/noticia';
import { obterUsuario } from '../../../../api/usuario';
import { JustImageDropzone } from '../../../../components/common/imageVideoDropzone/imageVideoDropzone';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PublicacaoParams } from '../../../../interfaces/publicacao.interface';
import { MdInfoOutline } from 'react-icons/md';
import { deletarSecretariaAssociada, listarSecretariasAtivas } from '../../../../api/secretarias';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const EditarPublicacaoRedeSocial: React.FC = () => {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];
  const { id } = useParams();

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    imagem: { value: string; error: boolean };
    links: { value: string; error: boolean };
    localizacao: { value: string; error: boolean };
    mensagem: { value: string; error: boolean };
    categoriaId: { value: string; error: boolean };
    redeId: { value: any[]; error: boolean };
    secretariaId: { value: any[]; error: boolean };
    usuarioId: { value: any; error: boolean };
    exigeAprovacao: { value: number; error: boolean };
  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    imagem: { value: '', error: false },
    links: { value: '', error: false },
    localizacao: { value: '', error: false },
    mensagem: { value: '', error: false },
    categoriaId: { value: '', error: false },
    secretariaId: { value: [], error: false },
    redeId: { value: [], error: false },
    usuarioId: { value: null, error: false },
    exigeAprovacao: { value: 0, error: false },
  });

  const [imageVideoBase64, setImageVideoBase64] = useState<string>('');
  const [categorias, setCategorias] = useState<any[]>([]);
  const [redes, setRedes] = useState<any[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [secretariasRemovidas, setSecretariasRemovidas] = useState<number[]>([]);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState<any[]>([]);
  const [isLoadingEditButton, setLoadingEditButton] = useState<boolean>(false);
  const [isLoadingRemoveButton, setLoadingRemoveButton] = useState<boolean>(false);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [tamanhoPagina, setTamanhoPagina] = useState(10);
  const [idUrl, setIdUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [contasCarregadas, setContasCarregadas] = useState<any[]>([]);
  const [arquivo, setArquivo] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);
  const [nomeCdn, setNomeCdn] = useState<any>(null);
  const [imagePreview, setImagePreview] = useState<string>("");
  const [temImagem, setTemImagem] = useState<boolean>(false)
  const [isAtivo, setIsAtivo] = useState<number>(1);
  const [getCodSituacaoPubli, setgetCodSituacaoPubli] = useState<number>(1);
  const [motivosReprovacao, setMotivosReprovacao] = useState('');
  const [getObjPendencia, setgetObjPendencia] = useState<any>();

  const fetchObterPublicacao = async () => {
    setIsLoading(true);
    try {
      const publicacaoData = await api.obterPublicacaoRedeSocial(Number(id));
      const {
        nomePublicacao,
        datPublicacao,
        dscPublicacao,
        dscEnderecoEvento,
        seqCategoria,
        conteudoSecretariaDTO,
        contasRedeSocial,
        binPublicacao,
        urlBin,
        pendencia,
      } = publicacaoData;

      const selecionadas = (conteudoSecretariaDTO ?? []).map((i: any) => Number(i.codSecretaria));

      setContasCarregadas(contasRedeSocial);

      if (publicacaoData.numRegistro == 0) {
        setIsAtivo(0)
      }

      if (publicacaoData.codSituacaoPubli) {
        setgetCodSituacaoPubli(publicacaoData.codSituacaoPubli)
      }

      if (pendencia && pendencia.dscObs) {
        setMotivosReprovacao(pendencia.dscObs);
      }

      if (publicacaoData.pendencia) {
        setgetObjPendencia(publicacaoData.pendencia)
      }

      let exigeAprovacaoValue = 0;
      if (pendencia && pendencia.seqSolicitante) {
        exigeAprovacaoValue = 1;
      }
      const usuarioIdValue = pendencia?.seqExecutor;

      let imagemValue = "";

      if (binPublicacao && binPublicacao.trim() !== "") {
        setTemImagem(true);
        imagemValue = binPublicacao;

        setImagePreview(atualizarPreview(binPublicacao));

        const delimiter = "%2F";
        const index = binPublicacao.lastIndexOf(delimiter);
        const finalFileName =
          index !== -1 ? binPublicacao.substring(index + delimiter.length) : binPublicacao;
        setNomeCdn(finalFileName);
      } else {
        setTemImagem(false);
      }

      setFormValues((prevValues) => ({
        ...prevValues,
        titulo: { value: nomePublicacao, error: false },
        mensagem: { value: dscPublicacao, error: false },
        localizacao: { value: dscEnderecoEvento, error: false },
        data: { value: datPublicacao || today, error: false },
        links: { value: urlBin || '', error: false },
        imagem: { value: imagemValue, error: false },
        categoriaId: { value: seqCategoria.toString(), error: false },
        secretariaId: { value: selecionadas, error: false },
        exigeAprovacao: { value: exigeAprovacaoValue, error: false },
        usuarioId: { value: usuarioIdValue, error: false },
        redeId: {
          value: contasRedeSocial.map((item: any) => ({
            seqConfigRede: item.seqConfigRede,
            seqId: item.seqId || null
          })),
          error: false
        },
      }));

      setSecretariaSelecionada(selecionadas);

    } catch (error) {
      console.error("Erro ao buscar dados da publicação:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const urlAtual = window.location.hash;
    const partesUrl = urlAtual.split('/');
    const idDaUrl = partesUrl[partesUrl.length - 3];

    setIdUrl(idDaUrl);
  }, []);

  useEffect(() => {
    if (idUrl) {
      const fetchRedeSocial = async () => {
        setIsLoading(true);
        try {
          const data = await api.listarContasRedesSociais(paginaAtual, tamanhoPagina, Number(idUrl));

          if (data.conteudo && data.conteudo.length > 0) {
            setRedes(data.conteudo.map((categoria: any) => ({
              seqConfigRede: categoria.seqConfigRede,
              seqId: categoria.seqId,
              dscUsuario: categoria.dscUsuario,
              datRegistro: categoria.datRegistro,
              sitRegistro: categoria.sitRegistro,
            })));
          } else {
            setRedes([]);
          }

        } catch (error) {
          console.error('Erro ao buscar contas em redes sociais:', error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchRedeSocial();
      fetchObterPublicacao();
    }
  }, [idUrl, paginaAtual, tamanhoPagina]);

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        
        const fetchObterUsuario = async () => {
          try {
           const [data, ativas] = await Promise.all([
             obterUsuario(Number(usuario.seqUsuario)),
             listarSecretariasAtivas()
           ]);
           setSecretarias(
            data.usuarioSecretariaDTO?.length ? data.usuarioSecretariaDTO : ativas
          );
          } catch (error) {
            console.error("Erro ao obter usuario:", error);
          }
        };
  
        fetchObterUsuario();
  
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    fetchCategorias();
    fetchAprovadoresAtivos();
  }, []);

  useEffect(() => {
    const fetchRedeSocial = async () => {
      setIsLoading(true);
      try {
        const data = await api.listarRedesSociais(paginaAtual, tamanhoPagina);
        setRedes(data.formatoArquivos || []);
      } catch (error) {
        console.error('Erro ao buscar ícones de redes sociais:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRedeSocial();
  }, []);

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await listarExecutores();
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleCheckboxSecretaria = (codSecretaria: number, checked: boolean) => {
    setSecretariaSelecionada(prev => {
      const next = checked
        ? Array.from(new Set([...prev, codSecretaria]))
        : prev.filter(id => id !== codSecretaria);
      return next;
    });

    setSecretariasRemovidas(prev =>
      checked
        ? prev.filter(id => id !== codSecretaria)
        : Array.from(new Set([...prev, codSecretaria]))
    );

    setFormValues((prev: any) => {
      const current: number[] = Array.isArray(prev?.secretariaId?.value) ? prev.secretariaId.value : [];
      const next = checked
        ? Array.from(new Set([...current, codSecretaria]))
        : current.filter(id => id !== codSecretaria);

      return {
        ...prev,
        secretariaId: { ...prev.secretariaId, value: next, error: prev?.secretariaId?.error ?? false },
      };
    });
  };

  const handleCheckboxChange = (rede: any, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setFormValues((prevValues: any) => {
      const updatedContasRedeSocial = isChecked
        ? [
          ...prevValues.redeId.value,
          { seqConfigRede: rede.seqConfigRede, seqId: rede.seqId || null }
        ]
        : prevValues.redeId.value.filter(
          (item: any) => item.seqConfigRede !== rede.seqConfigRede
        );

      return {
        ...prevValues,
        redeId: { value: updatedContasRedeSocial, error: false },
      };
    });
  };

  const handleDeleteSecretarias = async () => {
    try {
      for (const codSecretaria of secretariasRemovidas) {
        await deletarSecretariaAssociada(codSecretaria, Number(id));
      }

      setSecretariasRemovidas([]);
    } catch (error) {
      console.error('Erro ao remover páginas:', error);
    }
  };

  const atualizarPreview = (url: string): string => {
    if (url.startsWith("data:")) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${new Date().getTime()}`;
  };

  const handleImageSelected = async (selecionado: FileWithPath | null) => {
    if (selecionado) {
      const isImagem = selecionado.type.startsWith("image/");
      const isVideo = selecionado.type.startsWith("video/");
      const isAudio = selecionado.type.startsWith("audio/");

      setArquivo(selecionado);

      if (isImagem || isVideo || isAudio) {
        setArquivoSelecionado(selecionado);
        setArquivo(selecionado);
      } else {
        console.error("Tipo de arquivo não suportado.");
      }
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === "string") {
          const novaUrl = atualizarPreview(reader.result);
          setImagePreview(novaUrl);
          setFormValues((prev) => ({
            ...prev,
            imagem: { value: novaUrl, error: false },
          }));
        }
      };
      reader.readAsDataURL(selecionado);
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      setImagePreview("");
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const tituloRede = (codigo: number) => {
    const titles: { [key: number]: string } = {
      0: 'Facebook',
      1: 'Instagram',
      2: 'LinkedIn',
      3: 'Youtube',
      4: 'TikTok',
      5: 'X (Antigo Twitter)',
      6: 'Whatsapp',
      7: 'Telegram',
      8: 'Tumblr',
      9: 'Página Internet',
    };

    return titles[codigo] || '';
  };

  const iconeRedeSocial = (id: number) => {
    const icones: { [key: number]: { icon: any, color: string } } = {
      0: { icon: faFacebookSquare, color: "#1789fc" },
      1: { icon: faInstagram, color: "#ec1393" },
      2: { icon: faLinkedin, color: "#1DA1F2" },
      3: { icon: faYoutube, color: "#ff0000" },
      4: { icon: faTiktok, color: "#080404" },
      5: { icon: faXTwitter, color: "#080404" },
      6: { icon: faWhatsapp, color: "#43e460" },
      7: { icon: faTelegram, color: "#088ccc" },
      8: { icon: faTumblrSquare, color: "#384c5c" },
    };

    return icones[id] || { icon: faGlobe, color: "#3b87d8" };
  };

  function getMaxLength(id: number) {
    switch (Number(idUrl)) {
      case 0: return 63206;
      case 1: return 2200;
      case 2: return 3000;
      case 3: return 5000;
      case 4: return 2200;
      case 5: return 280;
      case 6: return 65536;
      case 7: return 4096;
      case 8: return 4096;
      default: return 200;
    }
  }

  function isImagemVideoObrigatorio(id: number) {
    switch (id) {
      case 4:
      case 3:
      case 1:
        return true;
      default:
        return false;
    }
  }

  const isFormValid = () => {
    const { titulo, data, categoriaId, redeId, usuarioId, exigeAprovacao } = formValues;

    if (exigeAprovacao.value == 1) {
      if (!usuarioId.value || usuarioId.value == null) {
        return false;
      }
    }

    const isValid = (
      titulo.value &&
      data.value &&
      categoriaId.value &&
      redeId.value.length > 0 &&
      (isImagemVideoObrigatorio(Number(idUrl)) ? imagePreview : true) &&
      (exigeAprovacao.value == 0 || (exigeAprovacao.value == 1 && usuarioId.value != null))
    );
    return isValid;
  }

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingEditButton(true);

    await handleDeleteSecretarias();

    const { links, localizacao, categoriaId, redeId, secretariaId, usuarioId, mensagem, data, imagem } = formValues;

    const pendencia = usuarioId.value
      ? {
        codPendencia: 1,
        seqSolicitante: seqUsuario,
        seqExecutor: usuarioId.value,
      }
      : null;

    const redesCarregadas = contasCarregadas.map((conta: any) => conta.seqId)
    const redesAtuais = redeId.value
      .map((rede: any) => rede.seqId)
      .filter((seqId: any) => seqId !== null);

    const redesRemovidas = redesCarregadas.filter((seqId: any) => !redesAtuais.includes(seqId));

    try {
      for (const seqId of redesRemovidas) {
        await api.deletarRelacionamentoConta(seqId);
      }

      if (getCodSituacaoPubli == 6) {
        getObjPendencia['codPendencia'] = 1;
      }

      let codSituacao = 1;

      if (data.value) {
        const dataDaPublicacao = data.value;
        const diaDeHoje = new Date().toISOString().split("T")[0];

        if (getObjPendencia) {
          codSituacao = 5;
        } else if (dataDaPublicacao > diaDeHoje) {
          codSituacao = 1;
        } else if (dataDaPublicacao === diaDeHoje) {
          codSituacao = 2;
        }
      } else {
        codSituacao = 2;
      }

      const params: PublicacaoParams = {
        seqConteudo: Number(id),
        codTipoPublicacao: 6,
        codSituacaoPubli: codSituacao,
        numRegistro: isAtivo,
        nomePublicacao: formValues.titulo.value || null,
        dscResumo: null,
        datPublicacao: formValues.data.value ? formValues.data.value : null,
        seqUsuario: seqUsuario,
        dscUsuarios: nomeUsuarioLogado,
        dscCitacaoUsuario: null,
        dscTags: null,
        binPublicacao: imagem.value || null,
        urlBin: null,
        dscPublicacao: mensagem.value || null,
        dscEnderecoEvento: null,
        seqCategoria: Number(categoriaId.value) || null,
        pendencia: getObjPendencia || null,
        contasRedeSocial: redeId.value.map((item: any) => ({
          seqConfigRede: item.seqConfigRede,
          seqId: item.seqId || null,
        })),
        numAprovacao: pendencia ? 1 : 0,
        numAprovado: 0,
        datInicioEvento: null,
        datFimEvento: null,
        dscHoraInicioEvento: null,
        dscHoraFimEvento: null,
        datDespublicar: null,
        dscCreditoImagem: null,
        dscCreditoNoticia: null,
        conteudoSecretariaDTO: secretariaId.value.map((id: number) => ({
          codSecretaria: id,
        })),
      };

      if (arquivoSelecionado && temImagem) {
        const formData = new FormData();
        const nomePasta = 'publicacoes';
        const nomeArquivo = nomeCdn || 'redeSocial';

        formData.append('file', arquivo);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);

        const cdnData = await api.editarRedeSocialNoCdn(formData);
        let cdnUrl = "";

        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }

        params.binPublicacao = cdnUrl;
      }

      if (arquivoSelecionado && !temImagem) {
        const formData = new FormData();

        const fileExtension = arquivoSelecionado.name.split('.').pop();
        let fileNameToSend = 'redeSocial';

        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }

        const nomePasta = 'publicacoes';
        const nomeArquivo = nomeCdn || 'redeSocial';

        formData.append('file', arquivo);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);

        const cdnData = await api.inserirRedeSocialNoCdn(formData);
        let cdnUrl = "";

        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }

        params.binPublicacao = cdnUrl;
      }

      await api.editarPublicacao(Number(id), params);
      setLoadingEditButton(false);

      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Publicação editada com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate(-1);
      });
    } catch (error) {
      setLoadingEditButton(false);
      console.error('Erro ao editar publicação:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao editar publicação. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate(-1);
      });
    }
  };

  const inativarPublicacao = async () => {
    if (getCodSituacaoPubli == 6) {
      getObjPendencia['codPendencia'] = 3;
    }

    Swal.fire({
      title: 'Tem certeza?',
      text: "Certeza que deseja inativar imediatamente a Publicação?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1789FC',
      cancelButtonColor: '#EDF2F7',
      confirmButtonText: 'Sim, inativar',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          pendencia: getObjPendencia || null,
          seqUsuario: seqUsuario,
          numRegistro: 0,
          codSituacaoPubli: 3
        };
        setLoadingRemoveButton(true);

        try {
          await api.editarPublicacao(Number(id), params);
          setLoadingRemoveButton(false);
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Rede social inativada com sucesso.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate(-1);
          });
        } catch (error) {
          setLoadingRemoveButton(false);
          console.error('Erro ao inativar rede social:', error);
          Swal.fire({
            icon: 'error',
            title: 'Ocorreu um erro!',
            text: 'Erro ao inativar rede social. Tente novamente mais tarde.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate(-1);
          });
        }
      }
    });
  };

  const mostrarMotivoReprovacao = () => {
    const texto = motivosReprovacao || 'Motivos não informados.';
    const isTextoLongo = texto.length > 150;

    Swal.fire({
      title: 'Motivos da Reprovação',
      width: isTextoLongo ? '50%' : undefined,
      html: `<div style="max-height: 250px; overflow-y: auto;">
              <p>${texto}</p>
            </div>`,
      icon: 'warning',
      confirmButtonColor: '#1789FC',
      confirmButtonText: 'Entendi'
    });
  };

  return (
    <Flex
      direction="column"
      padding='40px'
      background-color='#fafafa'
      width='100%'
      height={formValues.exigeAprovacao.value === 1 ? '100%' : '100%'}
      overflow='hidden'
    >
      <SettingsBreadcrumb />
      <Heading display={'flex'} alignItems={'center'} mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Publicação
      </Heading>
      <Heading display={'flex'} alignItems={'center'} mt="20px" fontWeight="500" fontSize="20px" color="#3b3b3b" w="100%">
        <FontAwesomeIcon
          style={{ marginRight: '10px', fontSize: '25px' }}
          icon={iconeRedeSocial(Number(idUrl)).icon}
          color={iconeRedeSocial(Number(idUrl)).color}
        />
        {`${tituloRede(Number(idUrl))}`}
      </Heading>
      {isAtivo == 0 && (
        <Flex justifyContent="end">
          <Alert status="error" mt="35px" borderRadius="md">
            <AlertIcon />
            <Box flex="1">
              <AlertTitle fontSize="lg" mb={1}>Publicação Inativada</AlertTitle>
              <AlertDescription display="block">
                Esta rede social foi permanentemente inativada e não poderá ser reativada.
              </AlertDescription>
            </Box>
          </Alert>
        </Flex>
      )}
      {getCodSituacaoPubli === 6 && (
        <Flex justifyContent="end">
          <Alert status="warning" mt="35px" borderRadius="md">
            <AlertIcon />
            <Box flex="1">
              <AlertTitle fontSize="lg" mb={1}>Publicação Reprovada</AlertTitle>
              <AlertDescription display="block">
                Após revisão, sua publicação não obteve aprovação.{' '}
                <Button variant="link" colorScheme="blue" onClick={mostrarMotivoReprovacao}>
                  Clique aqui para ver os motivos.
                </Button>
              </AlertDescription>
            </Box>
          </Alert>
        </Flex>
      )}
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.categoriaId.error}>
                  <FormLabel mb="8px">Categoria da Publicação</FormLabel>
                  <Select
                    placeholder='Selecione uma Categoria'
                    borderColor="gray.300"
                    _hover={{ borderColor: 'blue.500' }}
                    value={formValues.categoriaId.value}
                    onChange={(e) => handleFieldChange('categoriaId', e.target.value)}
                  >
                    {categorias.length > 0 ? (
                      categorias.map(categoria => (
                        <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                          {categoria.dscCategoria}
                        </option>
                      ))
                    ) : (
                      ''
                    )}
                  </Select>
                </FormControl>
              </div>
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Título da Publicação</FormLabel>
                  <CustomInput
                    value={formValues.titulo.value}
                    onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                    placeholder="Digite um título"
                    maxLength={100}
                  />
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl isInvalid={formValues.mensagem.error}>
                  <FormLabel mb="8px">
                    Mensagem/Descrição
                    <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                    <Tooltip
                      label="Insira hashtags (ex.: #exemplo) e links (ex.: https://www.exemplo.com), que serão automaticamente formatados para a publicação."
                      aria-label="Informação sobre a mensagem/Descrição"
                    >
                      <IconButton
                        className="icones"
                        icon={<MdInfoOutline />}
                        variant="link"
                        aria-label="Informação"
                        size="md"
                        color="#2883de"
                      />
                    </Tooltip>
                  </FormLabel>
                  <CustomTextArea
                    style={{ resize: 'none' }}
                    value={formValues.mensagem.value}
                    onChange={(e: any) => handleFieldChange('mensagem', e.target.value)}
                    placeholder="Digite uma mensagem ou descrição"
                    height={'145px'}
                    maxLength={getMaxLength(Number(idUrl))}
                  />
                  <FormHelperText>
                    Máximo de caracteres: {getMaxLength(Number(idUrl))}
                  </FormHelperText>
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl isRequired={isImagemVideoObrigatorio(Number(idUrl))}>
                  <FormLabel mb="8px">Mídia</FormLabel>
                  {imageVideoBase64 && imageVideoBase64.startsWith("data:video/") ? (
                    <video controls className='tamanho-video'>
                      <source src={imageVideoBase64} type="video/mp4" />
                      Seu navegador não suporta o formato de vídeo.
                    </video>
                  ) : (
                    <JustImageDropzone
                      base64={imagePreview}
                      onMediaSelected={handleImageSelected}
                      uploadMessage={`Arraste a imagem da publicação aqui ou clique para selecionar.`}
                      height={138}
                    />
                  )}
                  <input
                    id="image-upload"
                    type="file"
                    style={{ display: 'none' }}
                    accept="*"
                    onChange={(e) => handleImageSelected(e.target.files ? e.target.files[0] : null)}
                  />
                </FormControl>
              </div>
              <div className="col-md-3 mb-4">
                <Flex direction="row" justify="space-between" align="flex-start">
                  <FormControl>
                    <Flex justify="space-between" align="center" mb="8px">
                      <FormLabel mb="8px">
                        Escolha em quais contas deseja publicar
                        <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                      </FormLabel>
                    </Flex>

                    <div className="sidebar-checkbox-pagina">
                      <Stack spacing={5}>
                        {redes.length > 0 ? (
                          redes.map((rede) => (
                            <Flex
                              key={rede.seqConfigRede}
                              align="center"
                              justify="space-between"
                              direction={{ base: 'column', md: 'row' }}
                            >
                              <Checkbox
                                className="checkredes"
                                isChecked={formValues.redeId.value.some(
                                  (item: any) => Number(item.seqConfigRede) === Number(rede.seqConfigRede)
                                )}
                                onChange={(e) => handleCheckboxChange(rede, e)}
                              >
                                {rede.dscUsuario}
                              </Checkbox>
                            </Flex>
                          ))
                        ) : (
                          <p>Não há contas cadastradas.</p>
                        )}

                      </Stack>
                    </div>
                  </FormControl>
                </Flex>
              </div>
              <div className="col-md-3 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Data para Publicação</FormLabel>
                  <CustomInput
                    id="social-media-publication-date"
                    type="date"
                    value={formValues.data.value}
                    onChange={(e) => handleFieldChange('data', e.target.value)}
                    min={today}
                  />
                </FormControl>
              </div>
              <div className="col-md-6 mb-4">
                <FormControl>
                  {secretarias.length > 0 && (
                    <>
                      <Flex justify="space-between" align="center">
                        <FormLabel mb="8px">
                          Associe o usuário a uma secretaria (opcional)
                        </FormLabel>
                      </Flex>

                      <Box
                        border="1px solid"
                        borderColor="gray.300"
                        borderRadius="md"
                        p={3}
                      >
                        <Box overflow="hidden">
                          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <colgroup>
                              <col style={{ width: '60px' }} />
                              <col style={{ width: '120px' }} />
                              <col />
                            </colgroup>
                            <thead>
                              <tr>
                                <th style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' }}></th>
                                <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd', color: 'gray' }}>Código</th>
                                <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd', color: 'gray' }}>Secretaria</th>
                              </tr>
                            </thead>
                          </table>
                        </Box>

                        <Box
                          className="sidebar-checkbox-pagina"
                          overflowX="auto"
                          overflowY={secretarias.length > 5 ? 'auto' : 'visible'}
                          maxH={secretarias.length > 5 ? '240px' : 'unset'}
                        >
                          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <colgroup>
                              <col style={{ width: '60px' }} />
                              <col style={{ width: '120px' }} />
                              <col />
                            </colgroup>
                            <tbody>
                              {secretarias.map((secretaria: any) => {
                                const cod = Number(secretaria.codSecretaria);
                                const nome = secretaria.secretariasDTO?.dscSecretaria ?? secretaria.dscSecretaria ?? '—';

                                return (
                                  <tr key={cod}>
                                    <td style={{ textAlign: "center", padding: "8px", borderBottom: "1px solid #ddd" }}>
                                      <Checkbox
                                        className="checkCategorias"
                                        isChecked={secretariaSelecionada.includes(cod)}
                                        onChange={(e) => handleCheckboxSecretaria(cod, e.target.checked)}
                                      />
                                    </td>
                                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{cod}</td>
                                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{nome}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </Box>
                      </Box>
                    </>
                  )}
                </FormControl>
              </div>
            </div>

            <Flex hidden={isAtivo == 0} justifyContent="end">
              <Button
                m="6px"
                onClick={() => navigate(-1)}
              >
                Desistir
              </Button>
              <Button
                type="submit"
                m="6px"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={!isFormValid()}
                loadingText="Editando..."
                isLoading={isLoadingEditButton}
              >
                {getCodSituacaoPubli == 6
                  ? 'Reenviar para Aprovação'
                  : 'Editar Publicação'}
              </Button>
              <Button
                hidden={isAtivo == 0}
                onClick={() => inativarPublicacao()}
                m="6px"
                color="white"
                bgColor="red.500"
                _hover={{ bg: "red.600" }}
                loadingText="Desativando..."
                isLoading={isLoadingRemoveButton}
              >
                Inativar Publicação Imediatamente
              </Button>
            </Flex>
            {isAtivo == 0 && (
              <Flex mt="35px" justifyContent="end">
                <Button
                  color="#FFF"
                  bgColor="#1665D8"
                  m="6px"
                  onClick={() => navigate(-1)}
                >
                  Voltar
                </Button>
              </Flex>
            )}
          </form>
        </Box>
      )}
    </Flex>
  );
};

export default EditarPublicacaoRedeSocial;
